import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "parts/Cards/BlogCards/CenteredBlogCard";
// Image
import bgImage from "assets/images/contact.jpg";
function Information() {
  return (
    <MKBox
      component="section"
      py={12}
      sx={{
        pt: "100px",  // Adds space at the top to avoid overlap with fixed navbar
      }}
    >
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="User Behavior Analytics"
                    description="Detect Insider Threats and Unusual Activity
Our User Behavior Analytics (UBA) solution continuously monitors user activity to detect any abnormal behavior or signs of potential insider threats. By analyzing user behavior patterns, we can identify deviations from normal activity, enabling early detection of unauthorized access attempts and potential data breaches."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Malware Detection"
                    description="Identifying and Eliminating Malicious Software
Malware can compromise your systems, steal sensitive data, or cause irreparable damage. Our advanced malware detection tools identify, isolate, and remove malicious software from your network, keeping your systems secure from viruses, ransomware, spyware, and other harmful threats."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Authentication Bypass Attack Detection"
                    description="Prevent Unauthorized Access Attempts
Authentication bypass attacks attempt to circumvent login and security mechanisms to gain unauthorized access to systems. Our solution continuously monitors and identifies suspicious login activity, ensuring that any attempt to bypass authentication mechanisms is blocked before any harm is done."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="SQL Injection Attack Detection"
                    description="Prevent Exploits Targeting System Errors
SQL injection attacks exploit system vulnerabilities to manipulate databases and steal sensitive data. Our solution identifies and mitigates SQL injection attempts, preventing attackers from executing malicious SQL commands and gaining unauthorized access to your data."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Union-Based Attack Detection"
                    description="Mitigate UNION SQL Injection Attacks
Union-based SQL injection attacks involve using UNION queries to extract unauthorized data from databases. Our solution detects and blocks these types of attacks by analyzing database query patterns and preventing unauthorized database manipulation."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Distributed Denial of Service (DDoS) Detection"
                    description="Protect Against Large-Scale Traffic Attacks
DDoS attacks are designed to overwhelm and disrupt server operations by flooding a network with traffic. Our continuous monitoring solution detects large-scale traffic anomalies and helps mitigate DDoS attacks before they can cause downtime or damage to your systems."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Brute Force Attack Detection"
                    description="Stop Automated Password Guessing Attacks
Brute force attacks attempt to break into accounts by guessing passwords through automated means. Our system identifies and blocks repeated login attempts, preventing automated password-guessing attacks before they can succeed."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Credential Stuffing Attack Detection"
                    description="Prevent Exploits Using Stolen Login Credentials
Credential stuffing attacks involve using stolen login credentials to access user accounts across different services. Our system detects unusual login patterns, blocking malicious login attempts and protecting your users from account takeover."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Password Spraying Attack Detection"
                    description="Detect Low-Frequency Password Attacks
Password spraying attacks test common passwords across many accounts with low-frequency attempts to avoid detection. Our solution detects these attacks by monitoring login behavior and blocking unauthorized attempts across multiple accounts."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Directory Attack Detection"
                    description="Prevent Exploitation of Directory Services
Directory attacks target directory services to gain unauthorized access to organizational data. Our Directory Attack Detection technology monitors for unusual directory queries and access attempts, protecting your systems from unauthorized directory service exploitation."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Code Injection Attack Detection"
                    description="Protect Applications from Malicious Code
Code injection attacks insert malicious code into an application to exploit vulnerabilities and compromise functionality. Our solution detects and blocks code injections, ensuring the integrity of your applications and preventing unauthorized modifications."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Replay Attack Detection"
                    description="Protect Against Replay Attacks and Data Interception
Replay attacks involve intercepting and reusing valid data transmissions to impersonate users or systems. Our detection systems monitor network traffic for suspicious patterns and ensure that data is not being reused by unauthorized entities."
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={bgImage}
              title="Get insights"
              description="In today's rapidly evolving digital landscape, staying informed is key to making smart decisions. At HP Tech Solutions, we provide valuable insights into the latest trends, challenges, and opportunities in software development and cybersecurity."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "Contact",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
